<script setup lang="ts">
  import { computed } from 'vue';
  import { storeToRefs } from 'pinia';
  import closeIcon from '@/shared/assets/icons/CloseIcon.svg';
  import fileTextIcon from '@/shared/assets/icons/FileTextIcon.svg';
  import historyIcon from '@/shared/assets/icons/HistoryIcon.svg';
  import userIcon from '@/shared/assets/icons/user.svg';
  import type { DashboardMetric } from '../../model/dashboard.types';
  import { useDashboardStore } from '../../model/dashboard.store';
  import StatCard from '../StatCard.vue';

  const dashboardStore = useDashboardStore();
  const { data, isLoading, comparisonLabel } = storeToRefs(dashboardStore);

  interface CardEntry {
    title: string;
    icon: string | object;
    metric: DashboardMetric | undefined;
    valueSuffix?: string;
  }

  const cards = computed(() => {
    const totals = data.value?.documentTotals;
    const entries: CardEntry[] = [
      { title: 'Documentos Vigentes', icon: fileTextIcon, metric: totals?.active },
      { title: 'Documentos Obsoletos', icon: historyIcon, metric: totals?.obsolete },
      { title: 'Documentos Inativos', icon: closeIcon, metric: totals?.inactive },
      {
        title: 'Colaboradores',
        icon: userIcon,
        metric: data.value?.activeCollaborators,
        valueSuffix: 'ativos',
      },
    ];
    return entries.map(({ metric, ...card }) => ({
      ...card,
      value: metric?.value ?? null,
      variationPct: metric?.variationPct ?? null,
    }));
  });
</script>

<template>
  <div
    data-testid="document-totals-cards"
    class="flex gap-6"
  >
    <StatCard
      v-for="card in cards"
      :key="card.title"
      :title="card.title"
      :icon="card.icon"
      :value="card.value"
      :value-suffix="card.valueSuffix"
      :variation-pct="card.variationPct"
      :comparison-label="comparisonLabel"
      :loading="isLoading"
      :has-data="data !== null"
      class="h-[182px] min-w-0 flex-1"
    />
  </div>
</template>
